import { createRealGetRequest } from ".";
import { paths } from "../rolecountry.types";

export const realGetCountryAndRoleList = createRealGetRequest<
  paths["/exp/v1/dna/welcomeScreen/getCountryAndRoleList"]
>("/welcomeScreen/getCountryAndRoleList");
